import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { updateSettings } from 'ducks/settings/slices';
import { Button } from 'framework/button';
import { useAppDispatch } from 'store/hooks';

import { Page } from 'components/page/Page';

import cn from './404.module.scss';

const { PUBLIC_URL } = process.env;

export default () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(updateSettings({ loading: false }));
  }, [dispatch]);

  return (
    <Page title="404">
      <div className={cn.content}>
        <img src={`${PUBLIC_URL}/404.svg`} alt="Cognitiv 404 Error" height={120} />
        <p>
          Oops, looks like you are stranded!
          <br />
          The page you are trying to access doesn't exist.
          <br />
          Please navigate your way back to a working page.
        </p>
        <Button margin="16px 0px 0px 0px" width="160px" onClick={() => navigate('/application')}>
          Application
        </Button>
      </div>
    </Page>
  );
};
